var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 240,
    viewBox: "0 0 320 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7692_209485)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "#1f1f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.48,
    cx: 160.244,
    cy: 119.397,
    rx: 100,
    ry: 140,
    transform: "rotate(-60 160.244 119.397)",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 96L153.061 42.228C155.505 40.8456 158.495 40.8456 160.939 42.228L256 96V192C256 196.418 252.418 200 248 200H66C61.5817 200 58 196.418 58 192V96Z",
    fill: "#ABAAA8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 56,
    width: 160,
    height: 120,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 104,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 90,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 76,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 96L153.091 149.811C155.52 151.171 158.48 151.171 160.909 149.811L257 96V200C257 204.418 253.418 208 249 208H65C60.5817 208 57 204.418 57 200V96Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7692_209485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d3262cf7ad2c21f558e663475a4e9e1d.svg";
export { ForwardRef as ReactComponent };